import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'

// Auth Pages
import LoginPage from './pages/auth/LoginPage'
import RegisterPage from './pages/auth/RegisterPage'
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage'
import ResetPasswordPage from './pages/auth/ResetPasswordPage'

// Main Pages
import HomePage from './pages/home/HomePage'

// Profile Pages
import ProfilePage from './pages/profile/ProfilePage'

// Farm Pages
import FarmListPage from './pages/farm/FarmListPage'
import FarmDetailPage from './pages/farm/FarmDetailPage'
import FarmFormPage from './pages/farm/FarmFormPage'

// Cow Pages
import CowListPage from './pages/cow/CowListPage'
import CowDetailPage from './pages/cow/CowDetailPage'
import CowBehaviorPage from './pages/cow/CowBehaviorPage'
import CowFormPage from './pages/cow/CowFormPage'

// Finance Pages
import TransactionListPage from './pages/finance/TransactionListPage'

// Feeding Pages
import FeedingPage from './pages/feeding/FeedingPage'

// Cow Weight Pages
import CowWeightPage from './pages/cow-weight/CowWeightPage'

// Protected Route Component
function ProtectedRoute({ children }: { children: React.ReactNode }) {
  // ตรวจสอบว่า login หรือยัง (เช็คจาก localStorage)
  const isAuthenticated = localStorage.getItem('isLoggedIn') === 'true'

  if (!isAuthenticated) {
    // ถ้ายังไม่ login ให้ redirect ไป /login
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <HomePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <ProfilePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/farms"
          element={
            <ProtectedRoute>
              <FarmListPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/farms/new"
          element={
            <ProtectedRoute>
              <FarmFormPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/farms/:id"
          element={
            <ProtectedRoute>
              <FarmDetailPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/farms/:id/edit"
          element={
            <ProtectedRoute>
              <FarmFormPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/cows"
          element={
            <ProtectedRoute>
              <CowListPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/cows/:id"
          element={
            <ProtectedRoute>
              <CowDetailPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/cows/new"
          element={
            <ProtectedRoute>
              <CowFormPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/cows/:id/edit"
          element={
            <ProtectedRoute>
              <CowFormPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/cows/:id/behavior"
          element={
            <ProtectedRoute>
              <CowBehaviorPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/finance"
          element={
            <ProtectedRoute>
              <TransactionListPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/feeding"
          element={
            <ProtectedRoute>
              <FeedingPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/cow-weight"
          element={
            <ProtectedRoute>
              <CowWeightPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  )
}

export default App
